import { useEffect, useMemo, useState } from 'react';

import { getAnalyticsClient } from '../../clients/analytics-client';
import { type JiraSubProduct } from '../../model/site';
import { type Analytics } from './types';

function getAnalyticsSubproduct(appName: string, subProduct?: JiraSubProduct) {
	if (!subProduct) {
		return appName;
	}

	return `jira-${subProduct}-directory`;
}

/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */
export function useSetupAnalyticsClient(
	cloudId: string,
	appName: string,
	subProduct?: JiraSubProduct,
): Analytics | undefined {
	const analyticsSubProduct = useMemo(
		() => getAnalyticsSubproduct(appName, subProduct),
		[appName, subProduct],
	);

	const [analyticsClient, setAnalyticsClient] = useState<Analytics>(
		getAnalyticsClient({
			mode: appName,
			subproduct: analyticsSubProduct,
			cloudId,
		})!,
	);

	// setup analytics object
	useEffect(() => {
		if (!cloudId) {
			return;
		}

		const analytics = getAnalyticsClient({
			mode: appName,
			subproduct: analyticsSubProduct,
			cloudId,
		});
		setAnalyticsClient(analytics!);
	}, [cloudId, analyticsSubProduct, appName]);

	// TODO: fix-me - currently, cloudId is required to render People app.
	// When analytics client without cloud id is used, Cypress test `dev-packages/cypress/src/specs/analytics.spec.ts` is flaky.
	// It seems that the analytics client without cloud id used first, then analytics client with cloud is replaced, but the app does not re-render in Cypress tests.
	return cloudId ? analyticsClient : undefined;
}
